import React from "react";

function HeartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_2377_9738)">
        <path
          d="M12.6281 0.135938C12.4313 0.046875 12.2203 0 12 0C11.7797 0 11.5688 0.046875 11.3719 0.135938L2.54533 3.88125C1.51408 4.31719 0.745334 5.33438 0.750021 6.5625C0.773459 11.2125 2.68596 19.7203 10.7625 23.5875C11.5453 23.9625 12.4547 23.9625 13.2375 23.5875C21.3141 19.7203 23.2266 11.2125 23.25 6.5625C23.2547 5.33438 22.486 4.31719 21.4547 3.88125L12.6281 0.135938ZM6.75002 10.3734C6.75002 8.78906 8.0344 7.5 9.62346 7.5C10.3828 7.5 11.1141 7.80469 11.6531 8.33906L12 8.68594L12.3469 8.33906C12.886 7.8 13.6172 7.5 14.3766 7.5C15.961 7.5 17.25 8.78438 17.25 10.3734C17.25 11.1328 16.9453 11.8641 16.411 12.4031L12.5344 16.2797C12.2438 16.5703 11.7656 16.5703 11.475 16.2797L7.59846 12.4031C7.0594 11.8641 6.7594 11.1328 6.7594 10.3734H6.75002Z"
          fill="#3A57E8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2377_9738">
          <path d="M0 0H24V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HeartIcon;
